import { $ } from '@/libs/jquery/index'

export class EditingUserInformation {
  private from: string
  private to: string

  public setUser(userParameters: string): void {
    const parsedRequest: XMLDocument = $.parseXML(userParameters)

    this.from = this.parseContentFromXML(parsedRequest.querySelector('From'))
    this.to = this.parseContentFromXML(parsedRequest.querySelector('To'))
  }

  public showIn(selector: string): void {
    const tableHeader = `<thead><tr><th>Предыдущее значение</th><th>Новое значение</th></tr></thead>`
    const tableBody = `<tbody><tr><td></td><td></td></tr></tbody>`
    const container: JQuery = $(selector)
    container.append(`<table> ${ tableHeader }${ tableBody }</table>`)
    container.find('table td').first().html(this.from)
    container.find('table td').last().html(this.to)
  }

  private parseContentFromXML(domElement: HTMLElement): string {
    return domElement.innerHTML
      .replace(/\/></gi, 'nextline')
      .replace(/[<|\/>]/gi, '')
      .replace(/nextline/gi, '<br />')
  }
}
